import {
    Component,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
} from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { AppService } from '../../app.service';
import { CommsBlockoutService } from '../../services/comms-blockout/comms-blockout.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { MESSAGE_TITLE } from '../../enums/message-title';

@Component({
    selector: 'app-comms-blockout-settings',
    templateUrl: './comms-blockout-settings.component.html',
    styleUrl: './comms-blockout-settings.component.css',
})
export class CommsBlockoutSettingsComponent {
    @ViewChild('fileInput') fileInput: ElementRef | null = null;
    isDeleteModalVisible: boolean = false;
    isShowProgressSpinner: boolean = false;

    creditors: any | null = null;
    selectedCreditor: any | null = null;
    filteredCreditors: any[] = [];

    toEditId: number = 0;
    isActive: boolean = false;
    startDate: any = new Date();
    endDate: any = new Date();
    zipCode: any;
    reason: string = '';

    isSideBarVisible: boolean = false;
    commsBlockoutSettings!: any[];
    toDeleteId: number = 0;
    toDeleteType: string = '';

    selectedCreditors: any | undefined;
    hasClickedSearch: boolean = false;

    public constructor(
        private cdr: ChangeDetectorRef,
        private etlIngestionService: EtlIngestionService,
        private appService: AppService,
        private commsBlockoutService: CommsBlockoutService,
    ) {}

    ngOnInit() {
        this.etlIngestionService.getCreditors().subscribe((res: any) => {
            if (
                !!res &&
                !!res.Creditors &&
                Array.isArray(res.Creditors) &&
                res.Creditors.length > 0
            ) {
                this.creditors = res.Creditors;
            }
        });

        this.search();
    }

    get hasTableData(): boolean {
        return isArrayWithData(this.commsBlockoutSettings);
    }

    onChangeCreditor(event: any) {
        this.hasClickedSearch = false;
    }

    search() {
        this.isShowProgressSpinner = true;

        let creditorInputs;

        if (
            this.selectedCreditors &&
            Array.isArray(this.selectedCreditors) &&
            this.selectedCreditors.length > 0
        ) {
            creditorInputs = this.selectedCreditors
                .map((i: any) => i.CreditorId)
                .join(',');
        }

        this.commsBlockoutService
            .searchCommsBlockout(creditorInputs)
            .pipe(
                tap((res: any) => {
                    if (!!res && Array.isArray(res) && res.length > 0) {
                        this.commsBlockoutSettings = res;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.isShowProgressSpinner = false;
                    this.hasClickedSearch = true;
                }),
            )
            .subscribe();
    }

    filterCreditors(event: any) {
        let filteredItems: any[] = [];
        let query = event.query;

        for (let i = 0; i < (this.creditors as any[]).length; i++) {
            let item = (this.creditors as any[])[i];
            if (
                item.CreditorId.indexOf(query) !== -1 ||
                item.CompanyName.toLowerCase().indexOf(query.toLowerCase()) !==
                    -1
            ) {
                filteredItems.push(item);
            }
        }

        this.filteredCreditors = filteredItems;
    }

    onSelectCreditor(event: any) {}

    onFileSelected(event: any) {
        const file: File = event.target.files[0];

        //&& file.type === 'text/csv'
        if (file) {
            const formData = new FormData();
            formData.append('file', file, file.name);

            this.commsBlockoutService
                .uploadZipCode(formData)
                .pipe(
                    tap((res: any) => {
                        this.zipCode = res ? res.data : '';
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Zip Code File has been successfully uploaded.',
                        );
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.isShowProgressSpinner = false;
                        if (this.fileInput) {
                            this.fileInput.nativeElement.value = '';
                        }
                    }),
                )
                .subscribe();
        } else {
            this.appService.showCommonMessageDialog(
                'Validation',
                'Please select a valid csv file.',
            );
        }
    }

    onOpenSideBar(
        id: number = 0,
        creditorId: number = 0,
        startDate: any = null,
        endDate: any = null,
        zipCode: any = null,
        isActive: boolean = false,
        reason: string = '',
    ) {
        this.isSideBarVisible = true;

        if (!!creditorId) {
            this.selectedCreditor = this.creditors.find(
                (i: any) => i.CreditorId == creditorId,
            );
        }

        this.toEditId = id;
        this.startDate = startDate ? new Date(startDate) : new Date();
        this.endDate = endDate ? new Date(endDate) : new Date();
        this.zipCode = zipCode;
        this.isActive = isActive;
        this.reason = reason;
    }

    onOpenDeleteModal(id: any, type: string) {
        this.isDeleteModalVisible = true;
        this.toDeleteId = id || this.toEditId;
        this.toDeleteType = type;
    }

    onConfirmDelete() {
        if (!!this.toDeleteId) {
            this.isShowProgressSpinner = true;

            if (this.toDeleteType !== 'zipCode') {
                this.commsBlockoutService
                    .deleteCommsBlockout(this.toDeleteId)
                    .pipe(
                        tap(() => {
                            this.appService.showCommonMessageDialog(
                                'Success',
                                'Comms Block Settings has been successfully deleted.',
                            );
                            this.isDeleteModalVisible = false;
                            this.commsBlockoutSettings =
                                this.commsBlockoutSettings.filter(
                                    (i: any) => i.id !== this.toDeleteId,
                                );
                            this.cdr.detectChanges();
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {
                            this.isShowProgressSpinner = false;
                        }),
                    )
                    .subscribe();
            } else {
                this.commsBlockoutService
                    .deleteCommsBlockoutZipCode(this.toDeleteId)
                    .pipe(
                        tap(() => {
                            this.appService.showCommonMessageDialog(
                                'Success',
                                'Zip Codes has been successfully deleted.',
                            );
                            this.zipCode = null;
                            this.isDeleteModalVisible = false;
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {
                            this.isShowProgressSpinner = false;
                        }),
                    )
                    .subscribe();
            }
        }
    }

    onSave() {
        if (!this.toEditId) {
            const startDate =
                this.startDate.getFullYear() +
                '-' +
                (this.startDate.getMonth() + 1).toString().padStart(2, '0') +
                '-' +
                this.startDate.getDate().toString().padStart(2, '0');
            const endDate =
                this.endDate.getFullYear() +
                '-' +
                (this.endDate.getMonth() + 1).toString().padStart(2, '0') +
                '-' +
                this.endDate.getDate().toString().padStart(2, '0');

            this.commsBlockoutService
                .createCommsBlockout(
                    this.selectedCreditor.CreditorId,
                    startDate,
                    endDate,
                    this.zipCode,
                    this.isActive,
                    this.reason,
                )
                .pipe(
                    tap((res: any) => {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'New Comms Block Setting has been successfully created.',
                        );
                        this.isSideBarVisible = false;
                        this.search();
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.isShowProgressSpinner = false;
                    }),
                )
                .subscribe();
        } else {
            const startDate =
                this.startDate.getFullYear() +
                '-' +
                (this.startDate.getMonth() + 1).toString().padStart(2, '0') +
                '-' +
                this.startDate.getDate().toString().padStart(2, '0');
            const endDate =
                this.endDate.getFullYear() +
                '-' +
                (this.endDate.getMonth() + 1).toString().padStart(2, '0') +
                '-' +
                this.endDate.getDate().toString().padStart(2, '0');

            this.commsBlockoutService
                .editCommsBlockout(
                    this.toEditId,
                    +this.selectedCreditor.CreditorId,
                    startDate,
                    endDate,
                    this.zipCode,
                    this.isActive,
                    this.reason,
                )
                .pipe(
                    tap(() => {
                        this.appService.showCommonMessageDialog(
                            MESSAGE_TITLE.SUCCESS,
                            'Comms Block Setting has been successfully updated.',
                        );

                        this.isSideBarVisible = false;

                        const newSettings = this.commsBlockoutSettings.map(
                            (item: any) => {
                                if (item.Id === this.toEditId) {
                                    item.CreditorId =
                                        this.selectedCreditor.CreditorId;
                                    item.StartDate = startDate;
                                    item.EndDate = endDate;
                                    item.ZipCode = this.zipCode;
                                    item.IsActive = this.isActive;
                                    item.reason = this.reason;
                                }
                                return item;
                            },
                        );
                        this.commsBlockoutSettings = newSettings;
                        this.cdr.detectChanges();
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.isShowProgressSpinner = false;
                    }),
                )
                .subscribe();
        }
    }
}
